






















import ExchangeCard from "@/shared/components/molecules/ExchangeCardMolecule.vue"
import { computed, ComputedRef, defineComponent } from "@vue/composition-api"
import { useGetters, useActions } from "vuex-composition-helpers"

export default defineComponent({
    name: "ExchangeSubmit",
    components: { ExchangeCard },
    setup() {
        const {
            getLabels,
            getCanContinue,
            getInsurance,
            isEditable,
            getErrorMessage
        } = useGetters([
            'getLabels',
            'getCanContinue',
            'getInsurance',
            'isEditable',
            'getErrorMessage'
        ])
        const {
            addOrUpdateStudentExchangeNonPartner
        } = useActions([
            'addOrUpdateStudentExchangeNonPartner'
        ])

        const canContinue: ComputedRef = computed((): boolean => {
            return getCanContinue.value
        })
        
        const disabled: ComputedRef<boolean> = computed(() => !isEditable.value)
        
        function handleSubmit() {
            if(canContinue.value) {
                addOrUpdateStudentExchangeNonPartner()
            }
        }

        return {
            disabled,
            getLabels,
            canContinue,
            getInsurance,
            handleSubmit,
            getErrorMessage,
        }
    }
})
